import ArticlesIndex from '@components/pages/articles/ArticlesIndex';
import { ContentfulTags } from '@enums/ContentfulTags';
import { fetchEntries } from '@utils/contentful';

const ArticlesIndexPage = ({ posts }) => <ArticlesIndex posts={posts} />;

export async function getStaticProps() {
  const posts = await fetchEntries();

  if (posts && posts.length) {
    return {
      props: {
        posts: posts.filter((post) => !post.contentfulTags.includes(ContentfulTags.PRIVATE)),
      },
    };
  }
  return {
    props: {
      posts: [],
    },
  };
}

export default ArticlesIndexPage;
